import React, {useEffect,  useState} from "react";
import { useAuth } from "../../context/AuthContext";
import { fetchParkings, upsertParking } from "../../services/Administracion/parkingsService";
import { Parking } from "../../types/parking";
import ParkingModal from "./ParkingModal";



const ParkingList: React.FC = () => {
    const { user } = useAuth();
    const [parkings, setparkings] = useState<Parking[]>([]);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);
    const [selectedParking, setSelectedParking] = useState<Parking>({ parking_id: 0, parking_name: '', location: '', is_active: true, created_by: '', date_created: '' });
    const [showModal, setShowModal] = useState<boolean>(false);


    useEffect(() => {
        loadParkings();
    },[]);

    const loadParkings = async () => {
        setLoading(true);
        try {
            const data = await fetchParkings();
            const procesedParkings = data.map((parking: Parking) => ({
                ...parking,
            }));
            setparkings(procesedParkings);
        } catch (error: any) {
            setError(error.message || 'Error cargando parqueos')
        } finally {
            setLoading(false);
        }
    };

    const handleCreateParking = async (parking?: Parking) => {
        console.log('Building a editar: ', parking);
        setSelectedParking(parking || { parking_id: 0, parking_name: '', location: '', is_active: true, created_by: user?.User.email || '', date_created: '' });
        setShowModal(true);
    };

    const handleChangeStatusParking = async (parking: Parking) => {
        if (!parking.parking_id) return;
        if (!window.confirm(`¿Está seguro de ${parking.is_active ? 'desactivar' : 'activar'} el edificio: ${parking.parking_name}?`)) return;
        parking.is_active = !parking.is_active;
        try {
            await upsertParking(parking);
            loadParkings();
        } catch (error: any) {
            setError(error.message || "Error al desactivar el parqueo"); //error.message es el mensaje que viene del servidor
        }
    };

    const handleSaveParking = async (parking: Parking) => {
        setLoading(true);
        try {
            if(parking.parking_id){
                parking.updated_by = user?.User.email || '';
            } else {
                parking.created_by = user?.User.email || '';
            }
            const parkingActualizado =  await upsertParking(parking);
            console.log('Parqueo actualizado/creado: ', parkingActualizado);
            loadParkings();
        } catch (error: any) {
            setError(error.message || 'Error guardando el parqueo');
        } finally {
            setLoading(false);
            setShowModal(false);
        }
    }

    if (loading) {
        return <div>Cargando Parqueos...</div>;
    }
    if (error) {
        return <div>Error: {error}</div>;
    }


    return (
        <div className="container mt-4">
            <h4 className="mb-4">Mantinimiento de Parqueos</h4>
            <div className="mb-3 text-end">
                <button className="btn btn-primary" onClick={() => handleCreateParking()}>
                    Crear Parqueo
                </button>
            </div>
            <table className="table table-striped table-hover">
                <thead>
                    <tr>
                        <th>Id</th>
                        <th>Nombre</th>
                        <th>Ubicación</th>
                        <th>Activo</th>
                        <th>Fecha Creación</th>
                        <th>Acciones</th>
                    </tr>
                </thead>
                <tbody>
                    {parkings.map((parking) => (
                        <tr key={parking.parking_id}>
                            <td>{parking.parking_id}</td>
                            <td>{parking.parking_name}</td>
                            <td>{parking.location}</td>
                            <td>{parking.is_active ? 'Si': 'No'}</td>
                            <td>{new Date(parking.date_created).toLocaleString()}</td>
                            <td>
                                <button className="btn btn-sm btn-secondary me-2" onClick={() => handleCreateParking(parking)}>Editar</button>
                                <button
                                    className={`btn btn-sm ${parking.is_active ? 'btn-danger' : 'btn-success'}`}
                                    onClick={() => handleChangeStatusParking(parking)}
                                >
                                    {parking.is_active ? 'Desactivar' : 'Activar'}
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            {showModal && selectedParking && (
                <ParkingModal
                    parking={selectedParking}
                    onClose={() => setShowModal(false)}
                    onSave={handleSaveParking}
                />
            )}
        </div>
    );
} 

export default ParkingList;